// extracted by mini-css-extract-plugin
module.exports = {"root":"_ab96ba5f","caption":"_0ba64683","links":"_c0503f65","link":"_d00d65f9","max":"_6103ee44","telegram":"_5d66e34c","phone":"_5fea4d8d"};